// extracted by mini-css-extract-plugin
export default {"muteButton":"muteButton_muteButton__AchMI"};